import { NestedTreeControl } from '@angular/cdk/tree'
import { Component, OnInit } from '@angular/core'
import { MatTreeNestedDataSource } from '@angular/material/tree'
import { Router } from '@angular/router'
import { Subscription } from 'rxjs'
import { NotificationService } from '../../../../notification/shared/notification.service'
import { CommandeService } from '../../../linge-hebergement/shared/commande.service'
import { Lingerie } from '../../../linge-hebergement/shared/inventaire'
import { LingerieService } from '../../../settings/commande-param/commande-param-settings/shared/lingerie.service'
import { Client } from '../../../shared/client/client'
import { ClientService } from '../../../shared/client/client.service'

interface LingerieNode {
  id: number
  libelle: string
  children?: LingerieNode[]
}
@Component({
  selector: 'app-historique',
  templateUrl: './historique.component.html',
  styleUrls: ['./historique.component.scss']
})
export class HistoriqueComponent implements OnInit {

  subClient: Subscription
  currentClient: Client
  currentYear = (new Date()).getFullYear()
  listMoisAbv = ["Janv.", "Févr.", "Mars", "Avr.", "Mai", "Juin", "Juill.", "Août", "Sept.", "Oct.", "Nov.", "Déc."]
  listMois = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"]
  listAnnee = [this.currentYear]
  loading: Boolean = false
  isLingerie: Boolean = false
  lingeries
  statsLH
  listYearStatsLH

  treeControl1 = new NestedTreeControl<LingerieNode>(node => node.children)
  treeControl2 = new NestedTreeControl<LingerieNode>(node => node.children)
  dataSource = new MatTreeNestedDataSource<Lingerie>()

  isSante: Boolean = false
  isHotel: Boolean = false

  constructor(
    private clientService: ClientService,
    private commandeService: CommandeService,
    private router: Router,
    private lingerieService: LingerieService,
    private notificationService: NotificationService
  ) { }

  ngOnInit() {
    // Récupération des activités pour le client
    // Récupération des années disponibles (forcément année en cours)
    this.subClient = this.clientService.getCurrentClient().subscribe(client => {
      this.currentClient = client
      if (this.currentClient != null) {
        this.isLingeHebergementActivated()
        this.isLingerie = this.currentClient.is_comptage_lingerie || !this.currentClient.is_livraison_commande

        this.isSante = (this.currentClient.famille_client.cle_ref == '700' || this.currentClient.famille_client.parent?.cle_ref == '700')
        this.isHotel = (this.currentClient.famille_client.cle_ref == '600' || this.currentClient.famille_client.parent?.cle_ref == '600')

        if (this.isLingerie) {
          this.getLingeries()
        } else {
          this.getStatsLH(this.currentClient)
        }
      }
    })
  }

  ngOnDestroy() {
    if (this.subClient) {
      this.subClient.unsubscribe()
    }
  }

  refuse() {
    this.router.navigate(['/escli/statistic/stats-LH'])
  }

  getLingeries() {
    this.lingerieService.getLingeriesClient(this.currentClient.id).subscribe(data => {
      this.lingeries = data.sort((a, b) => a.libelle > b.libelle ? 1 : -1)
      this.getStatsLH(this.currentClient)
    })
  }

  getStatsLH(client) {
    this.commandeService.getClientStatsLH(client.id).subscribe(data => {
      this.statsLH = data
      this.statsLH.forEach(data => {
        if (this.listAnnee.indexOf(data.annee) == -1) {
          this.listAnnee.push(data.annee)
        }
      })
      this.listAnnee.sort((a, b) => b - a)

      if (this.isLingerie) {
        this.dataSource.data = this.lingeries.slice()
        this.dataSource.data = this.lingeries.slice()

        this.dataSource.data.forEach(value => {
          value['children'] = this.getStatsLHMonth(value)
        })
      }

      this.listYearStatsLH = this.getStatsLHMonth()
      this.loading = false
    })
  }

  /**
   * Permet de récupérer l'historique des données statistiques du linge d'hébergement
   * @param lingerie 
   * @returns la liste des données de statistiques du linge d'hébergement
   */
  getStatsLHMonth(lingerie = null) {
    let listYearStatsLH = []

    this.listAnnee.forEach(annee => {
      let listStatsLH = []
      this.listMois.forEach(mois => {
        let dataMois = this.statsLH.find(value => value.annee == annee && value.mois == this.listMois.indexOf(mois) + 1 && (!lingerie || value.lingerie.id == lingerie.id))
        listStatsLH.push({ jours: dataMois ? dataMois.nb_jours ?? this.getNbJoursMois(mois, annee) : this.getNbJoursMois(mois, annee), emplacements: dataMois ? dataMois.nb_emplacements ?? 'NC.' : 'NC.' })
      })
      listYearStatsLH.push({ annee: annee, list: listStatsLH })
    })

    return listYearStatsLH
  }

  /**
   * Récupération du nombre de jours du mois
   * @param mois 
   * @param annee 
   * @returns nombre de jours dans le mois
   */
  getNbJoursMois(mois, annee) {
    mois = this.listMois.indexOf(mois) + 1
    return new Date(annee, mois, 0).getDate()
  }

  isLingeHebergementActivated() {
    if (!this.currentClient.is_livraison_commande || this.currentClient.is_comptage_lingerie) {
      this.commandeService.getClientDotations(this.currentClient.id).subscribe(data => {
        if (data.length == 0) {
          this.router.navigate(['/escli/statistic/linge-hebergement']).then(() => {
            this.notificationService.notif(
              "Le linge d'hébergement n'est pas activé pour le compte client sélectionné",
              "warn"
            )
          })
        }
      })
    } else {
      let value = this.currentClient.is_livraison_commande && !this.currentClient.is_comptage_lingerie;
      if (!value) {
        this.router.navigate(['/escli/statistic/linge-hebergement']).then(() => {
          this.notificationService.notif(
            "Le linge d'hébergement n'est pas activé pour le compte client sélectionné",
            "warn"
          )
        })
      }
    }
  }
}
